import { isReviewed } from './version.js';
/**
 * Guard: refuse to calculate against an unreviewed rule set. Every calculator
 * calls this first so a missing review can never be silently treated as £0.
 */
export function assertReviewed(rules) {
    if (!isReviewed(rules.review)) {
        throw new Error(`Refusing to use unreviewed tax rules for ${rules.taxYear}. Complete the review gate first.`);
    }
}
//# sourceMappingURL=review.js.map